export enum PromptType {
  BROAD = "BROAD",
  NARROW = "NARROW",
}

export const promptTypeLabelMap: Record<PromptType, string> = {
  [PromptType.BROAD]: "Broad",
  [PromptType.NARROW]: "Narrow",
};
